var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"refinance-wizard-container"},[_c('transition',{attrs:{"name":"wizard-fade","mode":"out-in"}},[_c(_vm.currentPageComponent,{tag:"component"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }